import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "home",
  class: "d-flex align-items-center bg-gradient2 section-padding"
}
const _hoisted_2 = {
  key: 0,
  id: "container",
  class: "container"
}
const _hoisted_3 = { class: "row justify-content-center text-center" }
const _hoisted_4 = { class: "col-sm-12 col-lg-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "¡Felicidades, tu préstamo te espera!", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle text-white max700 mb-3" }, " Haz clic, completa tus datos y pídelo hoy mismo ", -1)
const _hoisted_7 = { class: "row justify-content-center pt-4" }
const _hoisted_8 = { class: "col-sm-6 col-lg-4" }
const _hoisted_9 = { class: "card-step" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "mb-3 d-flex flex-column justify-content-center align-items-center",
  style: {"min-height":"80px","max-height":"100px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "max80",
    src: "https://gondor-assets.s3.us-east-2.amazonaws.com/fintonic.png",
    alt: "fintonic"
  })
], -1)
const _hoisted_12 = { class: "no-style px-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("li", { class: "pb-2" }, " Resumen de tu prestamo: ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check px-2" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check px-2" }, null, -1)
const _hoisted_16 = { class: "row button mx-0" }
const _hoisted_17 = { class: "col-sm-12 p-1 bottom" }
const _hoisted_18 = { href: "https://leadgenios.net/click.track?CID=440310&AFID=467369&SID=ptlanding" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      (_ctx.data.loan && _ctx.data.period)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("ul", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("li", null, [
                            _hoisted_14,
                            _createTextVNode(" Monto: $" + _toDisplayString(_ctx.$filters.pluralizeAmount(_ctx.data.loan)) + ". ", 1)
                          ]),
                          _createElementVNode("li", null, [
                            _hoisted_15,
                            _createTextVNode(" Plazo: " + _toDisplayString(_ctx.$filters.pluralizeMonths(_ctx.data.period)) + ". ", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("a", _hoisted_18, [
                              _createVNode(_component_Button, {
                                label: "Continuar",
                                class: "bg-yellow-500 border-yellow-500 p-button-raised p-button-rounded font-weight-bold text-900"
                              })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}